import * as toggleGroup from '@zag-js/toggle-group';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';
import { Bold, Italic, Underline } from 'lucide-ripple';

export component ToggleGroup() {
	let service = useMachine(toggleGroup.machine, {
		id: 'toggle-group',
		defaultValue: 'bold',
		multiple: true,
	});
	let api = track(() => toggleGroup.connect(service, normalizeProps));

	<div {...@api.getRootProps()}>
		<button {...@api.getItemProps({ value: "bold" })}>
			<Bold size={16} />
		</button>
		<button {...@api.getItemProps({ value: "italic" })}>
			<Italic size={16} />
		</button>
		<button {...@api.getItemProps({ value: "underline" })}>
			<Underline size={16} />
		</button>
	</div>
}
